const actions = {
  getNotificacoes: async (context, { id, perPage, page, categoria }) => {
    const api = context.rootState.autenticacao.api;

    const response = await api.get(`/not/todas`, {
      params: {
        usuarioId: id,
        perPage,
        page,
        categoria,
      },
    });

    return response;
  },

  excluirNotificacao: async (context, { notificacaoId }) => {
    const api = context.rootState.autenticacao.api;

    const response = await api.delete(`not/${notificacaoId}/excluir`);

    return response;
  },

  vizualizarNotificacao: async (context, { id }) => {
    const api = context.rootState.autenticacao.api;

    const response = await api.put(`not/visualizar`, {
      usuarioId: id,
    });

    return response;
  },

  getCaregorias: async (context) => {
    const api = context.rootState.autenticacao.api;

    const response = await api.get(`/not/categorias`);

    return response;
  },

  assinarRelatorio: async (context, { fileUrl }) => {
    const api = context.rootState.autenticacao.api;

    const response = await api.get(`/common/file/signedUrl`, {
      params: {
        fileUrl,
      },
    });

    return response;
  },
};

export const notificacao = {
  namespaced: true,
  actions,
};
